/* -- Global graphQL query fields - only edit if schema changes -- */

// -- Images
export const imgFields = `
  node {
    id
    altText
    sourceUrl
    caption
  }
`;

// -- Links
export const linkFields = `
  target
  title
  url
`;

// -- Categories
export const catFields = `
  id
  uri
  name
  count
  # description
  # parentId
`;

export const pagFields = `
  pageInfo @include(if: $hasPag) {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
  
`;
// edges @include(if: $hasPag) {
//     cursor
//     node {
//       id
//       postId
//       title
//     }
//   }

// -- Video -- Clone
export const videoFields = `
  videoFields {
    videoType
    videoOptions
    # - Video
    videoEmbed
    videoFile {
      node {
        mediaItemUrl
      }
    }
    animatedSvg
    # - Video Options
    imageCover {
      ${imgFields}
    }
    loopingCover {
      node {
        mediaItemUrl
      }
    }
    playIcon
    # - File Options - videoFile only
    fileOptions
  }
`;

// -- Background Color
export const bgColorFields = `
  picker
  select
  type
  gradientDirection
  gradientColors {
    color
    stop
  }
`;

// -- Module General Settings
export const moduleGenSet = `
  id
  __typename
  module_id
  classes
  sectionText
  contentOptions
  titleFields {
    title
    subtitle
    subtitleOverTitle
    subtitleTag
    titleTag
    titleOrientation
    titlesColor
  }
  backgroundFields {
    backgroundColorOrImage
    backgroundImageOpacity
    hasOverlay
    backgroundOverlay
    backgroundImage {
      ${imgFields}
    }
    backgroundColor {
      colorSettings {
        ${bgColorFields}
      }
    }
  }
  hideModule
`;

// Slideshow Settings
export const slideSet = `
  carouselSettings {
    __typename
    arrowColor
    arrowsAroundPagination
    autoplayInterval
    carouselOptions
    controlsOverSlide
    hasCenterFocus
    paginationColor
    slideGap
    slidesToDisplay
    type
    customHeightFields {
      __typename
      heightType
      carouselMaxHeight
      slideFixedHeight
    }
    customWidthFields {
      __typename
      widthType
      carouselMaxWidth
      slideFixedWidth
    }
  }
`;

// -- Post Settings Groups
export const ptSetVars = `
  id
  __typename
  readMoreLabel
  taxonomyPostStyle
  searchPostStyle
  postContentOptions
  modulesPostStyle
  hasLink
  excerptLength
  displayStyles {
    standardItemSettings {
      __typename
      itemContentAlignment
      itemImageStyleSettings
      itemPadding
      itemStyleSettings
      itemsPerRow
      itemBackgroundColor {
        colorSettings {
          ${bgColorFields}
        }
      }
    }
    listItemSettings {
      __typename
      itemContentAlignment
      itemImageStyleSettings
      itemPadding
      itemStyleSettings
      itemsPerRow
      itemBackgroundColor {
        colorSettings {
          ${bgColorFields}
        }
      }
    }
  }
`;

// -- General Settings Option Page
export const genSetVars = `
  generalSettingsOptionsPage {
    generalSettingsACF {
      __typename
      id
      colorSettings {
        colorBrand
        colorBrandLight
        colorBrandDark
        colorBrandS1
        colorBrandS2
        colorBrandS3
        colorButton
        colorFont
        colorButtonH
        colorLink
        colorLinkH
        colorBody
      }
      fontsSettings {
        fontEmbed
        fontBody
        fontBodyLineHeight
        fontBodyRootSize
        fontBodyWeight
        fontButton
        fontButtonWeight
        fontHeading
        fontHeadingLineHeight
        fontHeadingWeight
        fontLinkDecoration
      }
      animations {
        animationsOptions
      }
    }
  }
`;

// -- Header / Footer Column Settings
export const layoutColSettings = `
  horizontalContent
  columnHorizontalOrientation
  columnVerticalOrientation
  columnSizeGrid
  columnGridLgPlus
  columnGridMdMinus
  columnGridMdToLg
  columnSizeFlex
  columnFlexLgPlus
  columnFlexMdMinus
  columnFlexMdToLg
`;
